export default {
    login: {
        userName: "User Name",
        password: "Password",
        login: "LOG-IN",
    },
    navbar: {
        home: "Home",
        contracts: "Contracts",
        settings: "Settings",
        info: "Info"
    },
    header: {
        home: "HOME",
        contracts: "CONTRACTS",
        settings: "SETTINGS",
        info: "INFO",
        contract: "CONTRACT",
        addService: "ADD SERVICE",
        service: "SERVICE",
    },
    home: {
        hello: "Hi"
    },
    contracts: {
        active: "Active",
        suspended: "Suspended",
        services: "Services",
        noSuspendedContracts: "There's not suspended contracts",
        noServices: "There's not pending services associates in this contract",
        noPressupost: "There's not pending payments in this contract",
        renovar: "Renew contract"
    },
    settings: {
        user: "USER",
        closeSession: "Log Out",
        settings: "SETTINGS",
        appLanguage: "App Language",
        confirmationText: "Are you sure you want to log out?"
    },
    info: {

    },
    addService: {
        addTitle: "Request a Service",
        editTitle: "Service",
        entrance: "Camping Entrance",
        exit: "Camping Exit",
        pickupAtParking: "Pick up caravan at the parking",
        deliveryAtParking: "Deliver caravan to the parking",
        doneText: "Done",
        cancelText: "Cancel",
        transportDate: "Transport Date",
        camping: "Camping",
        selectCamping: "-- Select --",
        parcel: "Parcel",
        selectParcel: "Select the parcel",
        save: "Save",
		payment: "Payment",
		paymentTitle: "Service Payment",
		servicePaymentConfirm: "Are you sure you want to proceed with the payment for this service?",
        toastMessage: "You must fill all the fields to save!",

        requestService: "Request this service",
        serviceSummary: "Service summary",
        total: "Total",
        paidService: "Service paid",
        transactionCompleted: "Transaction completed successfully",
        serviceConfirm: "Are you sure you want to request this service?",
        loading: "Requesting service...",

        reserveNum: "Reservation number",
        selectReserveNum: "Indicate the number",
        availableHoursInfo: "Available transport schedule: from {start} to {end}.",

        toastMessage2: "To request a service within the next 48 hours, please contact us."
    },
    service: {
        pending: "Pending",
        completed: "Completed",
        requestCompleted: "The service has been requested correctly"
    },
    contract: {
        entrance: "Entrance",
        exit: "Exit",
        registration: "Licence plate number",
        initialDate: "Start Date",
        finalDate: "End Date",
        zone: "Zone",
        parkType: "Parking Type",
        pendingServices: "Pending Services",
        completedServices: "Completed Services",
        pendingPressupost: "Pending payments",
        pendingPressupostS: "Pending payment",
        pay: "Pay",
        acceptConditions: "Accept terms and conditions",
        acceptConditionsTitle: "Terms and conditions",
        contractNumberRequired: "It is necessary to indicate the reservation number in order to be able to guarantee transportation"
    },
    interceptors : {
        noAuthorized: "Unauthorized user"
    },
    payment: {
        confirmed: "Payment Confirmed",
        confirmedExtended: "The payment was successfully completed",
        article: "Article",
        price: "Total",
        informEmail: "You will receive an email with the payment details",
        goBack: "Go Back",
        denied: "Payment Denied",
        deniedExtended: "There was a problem with the payment",
        deniedInfo: "Please try again in a few minutes, and if the problem persists, contact us"
    }
};